import { IHexSpaceData, IHexGridData } from 'js/bubbleCore/types';
import { getGridValue } from 'js/bubbleCore/utils/getGridValue';
import { getNeighbours } from 'js/bubbleCore/utils/getNeighbours';
import { Bubble } from 'js/bubbleCore/bubbles/types';
import { spacePositionToGridHex } from 'js/bubbleCore/utils/spacePositionToGridHex';
import { gridHexToSpacePosition } from 'js/bubbleCore/utils/gridHexToSpacePosition';
import { getDistance } from 'js/framework/utils/math-utils';
import {
  IEvent,
  EventType,
  Wall,
  createBubbleUpdatedEvent,
  createShootingSpaceGridCollisionEvent,
} from 'js/bubbleCore/events';
import { loopSpace } from 'js/bubbleCore/utils/loopSpace';

export function checkShootedGridCollisions(
  space: IHexSpaceData<Bubble>,
  grid: IHexGridData<Bubble>,
  events: IEvent[] = [],
): void {
  loopSpace(space, (bubble) => {
    const colliders = testBubbleGridCollision(bubble, grid);
    if (colliders) events.push(createShootingSpaceGridCollisionEvent(bubble, colliders));
  });
}

export function testBubbleGridCollision(bubble: Bubble, grid: IHexGridData<Bubble>): Bubble[] | null {
  const tempHex = spacePositionToGridHex(bubble.hexSpaceX, bubble.hexSpaceY, grid);
  tempHex.round();

  const potentialCollisions: Bubble[] = getNeighbours(grid, tempHex.offsetPosition.x, tempHex.offsetPosition.y);
  const onTop = getGridValue(grid, tempHex.offsetPosition.x, tempHex.offsetPosition.y);
  if (onTop) potentialCollisions.unshift(onTop);

  const collisions = potentialCollisions.filter((gridBubble) => {
    return checkFlyingBubbleGridBubbleCollision(bubble, gridBubble, grid);
  });

  return collisions.length > 0 ? collisions : null;
}

export function checkFlyingBubbleGridBubbleCollision(
  flyingBubble: Bubble,
  gridBubble: Bubble,
  grid: IHexGridData<Bubble>,
  radiusOverride?: number,
): boolean {
  const distance = getDistance(
    gridHexToSpacePosition(gridBubble.col, gridBubble.row, grid),
    {x: flyingBubble.hexSpaceX, y: flyingBubble.hexSpaceY}
  );
  return distance < (radiusOverride || flyingBubble.radius) + gridBubble.radiusInGrid;
}